export const myOwnFP_chart_palette = {
    // fills: [
    //     '#5C2983',
    //     '#0076C5',
    //     '#21B372',
    //     '#FDDE02',
    //     '#F76700',
    //     '#D30018'
    // ],

    // from here https://www.heavy.ai/blog/12-color-palettes-for-telling-better-stories-with-your-data
    fills: [
        "#ea5545", "#f46a9b", "#ef9b20", "#edbf33", "#ede15b", "#bdcf32", "#87bc45", "#27aeef", "#b33dc6",
        "#b30000", "#7c1158", "#4421af", "#1a53ff", "#0d88e6", "#00b7c7", "#5ad45a", "#8be04e", "#ebdc78",
        "#fd7f6f", "#7eb0d5", "#b2e061", "#bd7ebe", "#ffb55a", "#ffee65", "#beb9db", "#fdcce5", "#8bd3c7",
        "#e60049", "#0bb4ff", "#50e991", "#e6d800", "#9b19f5", "#ffa300", "#dc0ab4", "#b3d4ff", "#00bfa0"
    ],
    strokes: ["black"],
}


export const myOwnFP_chart_palette2 = {


    fills: [
        '#5C2983',
        '#0076C5',
        '#21B372',
        '#FCA401',
        '#F76700',
        '#D30018',
        '#f49886',
        '#a2b623',
        '#4c7b19',
        '#86a7f4',
        '#c386f4',
        '#f686d3',
        '#2a5510',
        '#28978a',
        '#6151f4',
        '#bb51f4',
        '#f451a8',
        '#a60606',
        '#4c587a',
    ],

    strokes: ["black"],
}

